import { render, staticRenderFns } from "./CaptiveFormsModalExtraFieldsForm.vue?vue&type=template&id=3f3e9e05&scoped=true"
import script from "./CaptiveFormsModalExtraFieldsForm.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsModalExtraFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsModalExtraFieldsForm.vue?vue&type=style&index=0&id=3f3e9e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e9e05",
  null
  
)

export default component.exports